module.exports = __webpack_public_path__ + "static/media/lap-1.33aff831.png";